export const INFURA_ID = process.env.REACT_APP_INFURA_ID ?? "";
export const WALLET_CONNECT_ID = process.env.REACT_APP_WALLET_CONNECT_ID ?? "";
export const WALLET_CONNECT_CHAIN = parseInt(
  process.env.REACT_APP_WALLET_CONNECT_CHAIN ?? ""
);

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
